import { parseMetaEnv } from "@/env";

/**
 * @deprecated should be phased out.
 * Is used because components that statically read from meta.env are initialized at the top level
 * (they don't have injectable context).
 * You should **not** add any new usage of this constant in new code.
 *
 * Use either
 *  - Manual dependency wiring if you're in pure TS code
 *  - const env = injectEnv() if you're in Vue realm
 */
let ENV: ReturnType<typeof parseMetaEnv>;

export function loadDeprecatedEnv() {
  if (ENV) {
    return ENV;
  }

  ENV = parseMetaEnv(import.meta.env);
  return ENV;
}
